'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectTab = selectTab;
exports.showTabs = showTabs;
function selectTab(tabId) {
  return {
    type: 'TAB_SELECTED',
    payload: tabId
  };
}

function showTabs() {
  var tabsToShow = {};

  for (var _len = arguments.length, tabIds = Array(_len), _key = 0; _key < _len; _key++) {
    tabIds[_key] = arguments[_key];
  }

  tabIds.map(function (e) {
    return tabsToShow[e] = true;
  });
  return {
    type: 'TAB_SHOWED',
    payload: tabsToShow
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@rafacdb/bah/lib/tabActions.js
// module id = 55
// module chunks = 0